export const moderation = {
  cancel: "キャンセル",
  blockList: {
    title: "ブロック中ユーザー",
    empty: "ブロックしているユーザーはいません",
    unblock: "解除",
  },
  block: {
    action: "ブロック",
    confirm: "このユーザーをブロックしますか？",
    confirmDescription: "ブロックすると相手とのやり取りができなくなります。",
    confirmAction: "ブロックする",
    done: "ブロックしました",
  },
  unblock: {
    confirm: "ブロックを解除しますか？",
    confirmAction: "解除する",
    success: "ブロックを解除しました",
    error: "解除に失敗しました",
  },
  report: {
    action: "通報する",
    confirm: "このユーザーを通報しますか？",
    confirmDescription: "不適切な行為があった場合、運営が確認・対応します。",
    confirmAction: "通報する",
  },
} as const;
